<template>
    <section>
        <v-layout column wrap align-center>
            <v-flex xs12 sm4>
                <div class="text-xs-center">
                    <h2 class="headline">Deliver your services in many ways...</h2>
                    <span class="subheading">Make us your partner to prosper your business</span>
                </div>
            </v-flex>
            <v-flex xs12>
                <v-container grid-list-xl>
                    <v-layout row wrap align-center>
                        <v-flex xs12 sm12 md4 @mouseleave="showCloud=false">
                            <v-card>
                                <v-img src="static/cloudcomputing.jpeg" aspect-ratio="2.75"></v-img>
                                <v-card-title primary-title>
                                    <div>
                                        <h3 class="headline mb-0">Cloud Software</h3>
                                    </div>
                                </v-card-title>

                                <v-card-actions>
                                    <v-btn icon @click="showCloud = !showCloud"><span class="more">more</span>
                                        <v-icon>{{ showCloud ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                                    </v-btn>
                                </v-card-actions>

                                <v-slide-y-transition>
                                    <v-card-text v-show="showCloud">
                                        Software hosting in the cloud. Our cloud solution leverages some of the best
                                        proven cloud technologies in large corporations. AWS, Heroku, Digital Ocean,
                                        Cloud Foundry and OpenStack
                                    </v-card-text>
                                </v-slide-y-transition>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm12 md4 @mouseleave="showConsulting=false">
                            <v-card>
                                <v-img src="static/consulting.jpg" aspect-ratio="2.75"
                                ></v-img>

                                <v-card-title primary-title>
                                    <div>
                                        <h3 class="headline mb-0">Consulting</h3>
                                    </div>
                                </v-card-title>

                                <v-card-actions @mouseleave="showConsulting=false">
                                    <v-btn icon @click="showConsulting = !showConsulting"><span class="more">more</span>
                                        <v-icon>{{ showConsulting ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}
                                        </v-icon>
                                    </v-btn>
                                </v-card-actions>

                                <v-slide-y-transition>
                                    <v-card-text v-show="showConsulting">
                                        Keeping your application running and perform. All our consultants are high
                                        skilled IT professionals with proven successful track record in helping
                                        companies modernizing legacy applications.
                                    </v-card-text>
                                </v-slide-y-transition>
                            </v-card>
                        </v-flex>
                        <v-flex xs12 sm12 md4 @mouseleave="showApp=false">
                            <v-card>
                                <v-img src="static/software.jpg" aspect-ratio="2.75"
                                ></v-img>

                                <v-card-title primary-title>
                                    <div>
                                        <h3 class="headline mb-0">Business Application</h3>
                                    </div>
                                </v-card-title>

                                <v-card-actions>
                                    <v-btn icon @click="showApp = !showApp"><span class="more">more</span>
                                        <v-icon>{{ showApp ? 'keyboard_arrow_down' : 'keyboard_arrow_up' }}</v-icon>
                                    </v-btn>
                                </v-card-actions>

                                <v-slide-y-transition>
                                    <v-card-text v-show="showApp">
                                        Build Custom business application taylor to your business needs.
                                        Resource management and planning. Our ERP products are easy to use. Contact us
                                        to find out how our ERP products can help you better manage and plan your
                                        staffs, inventories and customers
                                    </v-card-text>
                                </v-slide-y-transition>
                            </v-card>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </section>
</template>

<script>
    export default {
        name: "Business",
        data: () => ({
            showCloud: false,
            showConsulting: false,
            showApp: false
        })
    }
</script>

<style scoped>
    .v-card {
        width: 350px;
        alignment: top;
    }

    .more {
        font-size: 0.8em;
    }

</style>


// WEBPACK FOOTER //
// src/components/layout/sections/Business.vue